// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3IRtT","footer":"ReportModalFilter_footer__1N1yb"};